<p-dialog header="Add Event"
    [modal]="true"
    [(visible)]="visible"
    (onHide)="onDialogClose()"
    styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <p-card styleClass="mb-2 pt-3">
    <form [formGroup]="eventForm" (ngSubmit)="saveEvent()">
      <p-toast />
      <div class="formgrid grid">
        <!-- Row 1 -->
        <div class="field col-12 sm:col-6">
          <label for="eventCode" class="field-label required">Event Code</label>
          <input id="eventCode"
                  formControlName="eventCode"
                  type="text"
                  placeholder=""
                  data-cy="input-event-code"
                  pInputText />
          <small *ngIf="eventForm.get('eventCode')?.hasError('required') && eventForm.get('eventCode')?.touched" class="block p-error">
            Event code is required.
          </small>
          <small *ngIf="eventForm.get('eventCode')?.hasError('eventCodeExists') && eventForm.get('eventCode')?.touched" class="block p-error">
            Event code already exists.
          </small>
        </div>
        <div class="field col-12 sm:col-6">
          <label for="eventType" class="field-label required">Event Type</label>
          <p-dropdown id="eventType"
                      formControlName="eventTypeId"
                      [options]="eventTypes"
                      data-cy="dropdown-event-type"
                      placeholder="Please Select"></p-dropdown>
          <small *ngIf="eventForm.get('eventTypeId')?.hasError('required') && eventForm.get('eventTypeId')?.touched" class="block p-error">Event type is required.</small>
        </div>

        <!-- Row 2 -->
        <div class="field col-12 sm:col-6">
          <label for="description">Description</label>
          <textarea id="description" formControlName="eventDescription" rows="3" pInputTextarea data-cy="input-description"></textarea>
        </div>
        <div class="field col-12 sm:col-6">
          <label for="location">Location</label>
          <input id="location" formControlName="location" type="text" pInputText data-cy="input-location" />
        </div>

        <!-- Row 3 -->
        <div class="field col-12 sm:col-6">
          <label for="campaignYear" class="field-label">Campaign Year</label>
          <input id="campaignYear" formControlName="campaignYear" type="number" pInputText data-cy="input-year"  />
          <small *ngIf="eventForm.get('campaignYear')?.invalid && eventForm.get('campaignYear')?.touched" class="block p-error">Campaign year must be a 4-digit number.</small>
        </div>
        <div class="field col-12 sm:col-6">
          <label for="eventBudget" class="field-label">Event Budget</label>
          <input
            id="eventBudget"
            formControlName="eventBudget"
            type="text"
            pInputText
            data-cy="input-event-budget"
            (input)="onAmountInput($event)"
          />
          <small *ngIf="eventForm.get('eventBudget')?.invalid && eventForm.get('eventBudget')?.touched" class="block p-error">
            Event budget must be a valid amount (up to 2 decimal places)
          </small>
        </div>

        <!-- Row 4 -->
        <div class="field col-12 sm:col-6">
          <label for="startDate" class="field-label">Start Date</label>
          <p-calendar id="startDate" formControlName="startDate" [showIcon]="true" [iconDisplay]="'input'" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" data-cy="input-start-date"></p-calendar>
          <small *ngIf="eventForm.get('startDate')?.invalid && eventForm.get('startDate')?.touched" class="block p-error">Please select a start date.</small>
        </div>
        <div class="field col-12 sm:col-6">
          <label for="endDate" class="field-label">End Date</label>
          <p-calendar id="endDate" formControlName="endDate" [showIcon]="true" [iconDisplay]="'input'" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" data-cy="input-end-date"></p-calendar>
          <small *ngIf="eventForm.get('endDate')?.invalid && eventForm.get('endDate')?.touched" class="block p-error">Please select a end date.</small>
          <small *ngIf="eventForm.hasError('dateRangeInvalid')" class="block p-error">
            Start date must be earlier than end date.
          </small>
        </div>
      </div>

    </form>
  </p-card>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <button type="button" pButton label="Cancel" (click)="this.eventForm.reset(); onCancel.emit()" class="p-button-text" data-cy="btn-cancel"></button>
    <button type="submit" (click)="saveEvent()" pButton label="Save" data-cy="btn-save"></button>
  </ng-template>
  <!-- {{eventData|json}} -->
</p-dialog>
